<template>
  <v-container>
    <v-toolbar elevation="0">
      <!--<v-app-bar-nav-icon></v-app-bar-nav-icon> -->

      <v-toolbar-title
        ><h5 style="color: #424242" class="font-weight-regular">
          {{ content }}
        </h5></v-toolbar-title
      >

      <v-spacer></v-spacer>
      <!--
      <DropButton></DropButton> -->
      <v-btn color="dark" @click="logout" outlined small>Sair</v-btn>
    </v-toolbar>

    <v-img
      class="d-block mx-auto mt-8"
      max-width="120px"
      src="../assets/quiz.svg"
    ></v-img>
    <v-row align="center" justify="center">
      <p
        v-if="!isCompliance"
        style="width: 480px"
        class="text-center mt-8 px-4"
      >
        Este é um teste que está sendo estudado de maneira científica para ser
        utilizado em candidatos e colaboradores de empresas. Agradecemos sua
        participação e colaboração.
      </p>
      <p v-else style="width: 480px" class="text-center mt-8 px-4">
        Este é um teste que avalia sua posição diante de algumas situações. O
        tempo estimado é de  35 - 40 minutos e as questões requerem respostas "Sim e
        Não". Atente-se com a barra de tempo
      </p>
    </v-row>
    <v-row align="center" justify="center" class="mt-8 mb-12">
      <v-btn color="primary" @click="preAssessment" class="font-weight-bold"
        >Iniciar teste</v-btn
      >
    </v-row>

    <v-dialog persistent v-model="detectMobileDialog" width="500">
      <v-card>
        <v-card-title class=""> ATENÇÃO </v-card-title>

        <v-card-text>
          Detectamos que você está acessando o teste de um celular. É necessário
          utilizar um computador.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="isMobileDetected()"
            >Entendi</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <p class="text-center mt-16 font-weight-regular">versão 0.2.14</p>
  </v-container>
</template>

<script>
import DropButton from "../components/DropButton.vue";
import { router } from "../router";
import { auth, db } from "../../firebase";

export default {
  name: "Home",
  data() {
    return {
      detectMobileDialog: false,
      dialog: false,
      selected: false,
      content: "INÍCIO",
      items: [
        {
          action: "15 min",
          headline: "Chamada",
          title: "Título",
          subtitle: "Descrição",
        },
      ],
    };
  },
  components: {
    DropButton,
  },
  computed: {
    
    isCompliance() {
      return (
        (this.$route.query?.t && this.$route.query.t === "compliance") ||
        this.$store.state?.userProfile?.user_type === 2
      );
    }, 
  },
  methods: {
    preAssessment() {
      this.dialog = true;
      router.push({ name: "start" });
    },
    logout(event) {
      this.$store.dispatch("logout");
    },
    isMobileDetected() {
      this.detectMobileDialog = false;
      this.logout();
    },
  },
  async mounted() {
    if (this.$isMobile()) {
      this.detectMobileDialog = true;
    }
     const doc = await new Promise((resolve) => {
      const doc = db
        .collection("cadastro_coleta_2")
        .doc(auth.currentUser.uid)
        .get();
      resolve(doc);
    });
    this.$store.commit("setUserProfile", doc.data());
  },
};
</script>
